import {hasExplicitV4AccountManagement, managesV4Account} from "../../utils/v4Permissions";
import {isV4ManagerFlagged} from "../../utils/v4AccountTree";
import {isV4ManagerScope} from "../../utils/v4Session";

// A marked scope is final (a flagged root enters as a portal); only an unmarked one reads the flag.
export function isV4ManagerBoot(sessionScope, account) {
  if (!sessionScope?.accountId) return false;
  return typeof sessionScope.manager === 'boolean'
    ? isV4ManagerScope(sessionScope)
    : isV4ManagerFlagged(account?.settings);
}

// A bare `*` (every Full-access customer holds one) also needs the manager flag or a customer.
export function* v4BootManagesAccounts({arcId, sessionScope, account, permissions, ownId}, ownsCustomers) {
  if (arcId) return false;
  if (isV4ManagerBoot(sessionScope, account)) return true;
  if (sessionScope) return false;
  const ownFlagged = isV4ManagerFlagged(account?.settings);
  if (!permissions) return ownFlagged || (yield* ownsCustomers(ownId));
  return hasExplicitV4AccountManagement(permissions, ownId)
    || (managesV4Account(permissions, ownId) && (ownFlagged || (yield* ownsCustomers(ownId))));
}
